import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import SettingTextField from "./SettingTextField";
import OrderTypeSelector from "./OrderTypeSelector";

import { ReactComponent as CloseIcon } from "../assets/images/close.svg";

const AddRestaurantCategoryModal = ({ open, itemData, onSubmit, onClose, isLoading }) => {
  const [name, setName] = useState(itemData?.name ?? "");
  const [excludedOrderTypes, setExcludedOrderTypes] = useState(itemData?.excludedOrderTypes ?? []);
  const [error, setError] = useState(null);

  useEffect(() => {
    setName(itemData?.name ?? "");
    setExcludedOrderTypes(itemData?.excludedOrderTypes ?? []);
  }, [itemData]);

  const onSubmitCategory = () => {
    let err = null;
    if (name.trim() === "") err = { name: "Name is required" };

    setError(err);
    if (err) return;

    onSubmit(itemData ? { ...itemData, name, excludedOrderTypes } : { name, excludedOrderTypes })
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          border: 0,
          p: 4,
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography
            variant="h6"
            component="h2"
            sx={{
              fontFamily: "GilroyBold",
              fontSize: 18,
            }}
          >
            {itemData?._id ? "Edit" : "Add"} Category
          </Typography>
          <CloseIcon style={{ cursor: "pointer" }} onClick={onClose} />
        </Box>

        <Box mt={2}>
          <SettingTextField
            page={"AddRestaurantCategoryModal"}
            editable={true}
            value={name}
            setValue={(val) => setName(val)}
            placeholder={"Name"}
            required={true}
            variant={"filled"}
            border={"1px solid #AAA"}
            borderRadius={"5px"}
            error={error?.name}
          />
        </Box>
        
        <Box mt={2}>
          <OrderTypeSelector
            selectedTypes={excludedOrderTypes}
            onChange={setExcludedOrderTypes}
            disabled={isLoading}
          />
        </Box>
        
        <Box mt={2} display={"flex"} justifyContent={"flex-end"}>
          <Button
            type="button"
            disabled={isLoading}
            sx={{
              backgroundColor: "#000",
              color: "#FFF",
              width: 100,
              opacity: isLoading ? 0.2 : 1,
              fontFamily: "GilroyBold",
              fontSize: 14,
              borderRadius: 1,
              "&:hover": {
                backgroundColor: "#000 !important",
              },
            }}
            onClick={isLoading ? null : onSubmitCategory}
          >
            {itemData?._id ? "Update" : "Save"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddRestaurantCategoryModal;
